import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LogIn } from 'lucide-react';
import { Button } from '@/components/Button';
import { loginWithDialog } from '@/auth/cognito';

export function LoginPane() {
  const { t } = useTranslation();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [insideOffice, setInsideOffice] = useState(true);

  useEffect(() => {
    const inOffice =
      typeof Office !== 'undefined' &&
      typeof Office.context?.ui?.displayDialogAsync === 'function';
    setInsideOffice(inOffice);
  }, []);

  const onClick = async () => {
    setError(null);
    setLoading(true);
    try {
      await loginWithDialog();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'auth_failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex h-full flex-col items-center justify-center gap-6 px-6 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-lex-magenta/10 text-lex-magenta">
        <LogIn className="h-6 w-6" />
      </div>
      <div className="space-y-2">
        <h1 className="text-base font-semibold">{t('auth.login')}</h1>
        <p className="max-w-xs text-xs text-lex-slate-500">
          {t('auth.loginHint')}
        </p>
      </div>
      <Button onClick={onClick} disabled={loading}>
        {loading ? t('common.loading') : t('auth.loginCta')}
      </Button>
      {!insideOffice ? (
        <p className="max-w-xs text-[11px] text-lex-slate-500">
          {t(
            'auth.previewHint',
            'Estás viendo el complemento en el navegador. Para usarlo, instalalo en Word o Excel desde Settings → Lex Suite para Office.',
          )}
        </p>
      ) : null}
      {error ? (
        <p className="text-xs text-red-600">
          {t('common.error')}: {error}
        </p>
      ) : null}
    </div>
  );
}
